// Generated with:
//  for (let f in P5Loader.prototype) {
//    console.log(f, typeof P5Loader.prototype[f]);
//

const P5LoaderPrototypeInfo = {
  '_initializeInstanceVariables': 'function',
  'P2D': 'string',
  'WEBGL': 'string',
  'ARROW': 'string',
  'CROSS': 'string',
  'HAND': 'string',
  'MOVE': 'string',
  'TEXT': 'string',
  'WAIT': 'string',
  'HALF_PI': 'number',
  'PI': 'number',
  'QUARTER_PI': 'number',
  'TAU': 'number',
  'TWO_PI': 'number',
  'DEGREES': 'string',
  'RADIANS': 'string',
  'DEG_TO_RAD': 'number',
  'RAD_TO_DEG': 'number',
  'CORNER': 'string',
  'CORNERS': 'string',
  'RADIUS': 'string',
  'RIGHT': 'string',
  'LEFT': 'string',
  'CENTER': 'string',
  'TOP': 'string',
  'BOTTOM': 'string',
  'BASELINE': 'string',
  'POINTS': 'number',
  'LINES': 'number',
  'LINE_STRIP': 'number',
  'LINE_LOOP': 'number',
  'TRIANGLES': 'number',
  'TRIANGLE_FAN': 'number',
  'TRIANGLE_STRIP': 'number',
  'QUADS': 'string',
  'QUAD_STRIP': 'string',
  'TESS': 'string',
  'CLOSE': 'string',
  'OPEN': 'string',
  'CHORD': 'string',
  'PIE': 'string',
  'PROJECT': 'string',
  'SQUARE': 'string',
  'ROUND': 'string',
  'BEVEL': 'string',
  'MITER': 'string',
  'RGB': 'string',
  'HSB': 'string',
  'HSL': 'string',
  'AUTO': 'string',
  'ALT': 'number',
  'BACKSPACE': 'number',
  'CONTROL': 'number',
  'DELETE': 'number',
  'DOWN_ARROW': 'number',
  'ENTER': 'number',
  'ESCAPE': 'number',
  'LEFT_ARROW': 'number',
  'OPTION': 'number',
  'RETURN': 'number',
  'RIGHT_ARROW': 'number',
  'SHIFT': 'number',
  'TAB': 'number',
  'UP_ARROW': 'number',
  'BLEND': 'string',
  'REMOVE': 'string',
  'ADD': 'string',
  'DARKEST': 'string',
  'LIGHTEST': 'string',
  'DIFFERENCE': 'string',
  'SUBTRACT': 'string',
  'EXCLUSION': 'string',
  'MULTIPLY': 'string',
  'SCREEN': 'string',
  'REPLACE': 'string',
  'OVERLAY': 'string',
  'HARD_LIGHT': 'string',
  'SOFT_LIGHT': 'string',
  'DODGE': 'string',
  'BURN': 'string',
  'THRESHOLD': 'string',
  'GRAY': 'string',
  'OPAQUE': 'string',
  'INVERT': 'string',
  'POSTERIZE': 'string',
  'DILATE': 'string',
  'ERODE': 'string',
  'BLUR': 'string',
  'NORMAL': 'string',
  'ITALIC': 'string',
  'BOLD': 'string',
  'BOLDITALIC': 'string',
  '_DEFAULT_TEXT_FILL': 'string',
  '_DEFAULT_LEADMULT': 'number',
  '_CTX_MIDDLE': 'string',
  'LINEAR': 'string',
  'QUADRATIC': 'string',
  'BEZIER': 'string',
  'CURVE': 'string',
  'STROKE': 'string',
  'FILL': 'string',
  'TEXTURE': 'string',
  'IMMEDIATE': 'string',
  'IMAGE': 'string',
  'NEAREST': 'string',
  'REPEAT': 'string',
  'CLAMP': 'string',
  'MIRROR': 'string',
  'LANDSCAPE': 'string',
  'PORTRAIT': 'string',
  '_DEFAULT_STROKE': 'string',
  '_DEFAULT_FILL': 'string',
  'GRID': 'string',
  'AXES': 'string',
  '_preloadMethods': 'object',
  '_registeredMethods': 'object',
  '_registeredPreloadMethods': 'object',
  '_frameRate': 'number',
  '_lastFrameTime': 'number',
  '_targetFrameRate': 'number',
  'print': 'function',
  'frameCount': 'number',
  'deltaTime': 'number',
  'focused': 'boolean',
  'cursor': 'function',
  'frameRate': 'function',
  'getFrameRate': 'function',
  'setFrameRate': 'function',
  'noCursor': 'function',
  'displayWidth': 'number',
  'displayHeight': 'number',
  'windowWidth': 'number',
  'windowHeight': 'number',
  '_onresize': 'function',
  'width': 'number',
  'height': 'number',
  'fullscreen': 'function',
  'pixelDensity': 'function',
  'displayDensity': 'function',
  'getURL': 'function',
  'getURLPath': 'function',
  'getURLParams': 'function',
  '_helpForMisusedAtTopLevelCode': 'function',
  'pushStyle': 'function',
  'popStyle': 'function',
  'popMatrix': 'function',
  'pushMatrix': 'function',
  '_promisePreloads': 'object',
  'registerPromisePreload': 'function',
  '_setupPromisePreloads': 'function',
  '_wrapPromisePreload': 'function',
  '_legacyPreloadGenerator': 'function',
  'camera': 'function',
  'perspective': 'function',
  'ortho': 'function',
  'frustum': 'function',
  'createCamera': 'function',
  'setCamera': 'function',
  'setAttributes': 'function',
  '_assert3d': 'function',
  'createCanvas': 'function',
  'resizeCanvas': 'function',
  'noCanvas': 'function',
  'createGraphics': 'function',
  'blendMode': 'function',
  'noLoop': 'function',
  'loop': 'function',
  'push': 'function',
  'pop': 'function',
  'redraw': 'function',
  'applyMatrix': 'function',
  'resetMatrix': 'function',
  'rotate': 'function',
  'rotateX': 'function',
  'rotateY': 'function',
  'rotateZ': 'function',
  'scale': 'function',
  'shearX': 'function',
  'shearY': 'function',
  'translate': 'function',
  '_normalizeArcAngles': 'function',
  'arc': 'function',
  'ellipse': 'function',
  'circle': 'function',
  '_renderEllipse': 'function',
  'line': 'function',
  'point': 'function',
  'quad': 'function',
  'rect': 'function',
  'square': 'function',
  '_renderRect': 'function',
  'triangle': 'function',
  'ellipseMode': 'function',
  'noSmooth': 'function',
  'rectMode': 'function',
  'smooth': 'function',
  'strokeCap': 'function',
  'strokeJoin': 'function',
  'strokeWeight': 'function',
  'bezier': 'function',
  'bezierDetail': 'function',
  'bezierPoint': 'function',
  'bezierTangent': 'function',
  'curve': 'function',
  'curveDetail': 'function',
  'curveTightness': 'function',
  'curvePoint': 'function',
  'curveTangent': 'function',
  'beginContour': 'function',
  'beginShape': 'function',
  'bezierVertex': 'function',
  'curveVertex': 'function',
  'endContour': 'function',
  'endShape': 'function',
  'quadraticVertex': 'function',
  'vertex': 'function',
  'alpha': 'function',
  'blue': 'function',
  'brightness': 'function',
  'color': 'function',
  'green': 'function',
  'hue': 'function',
  'lerpColor': 'function',
  'lightness': 'function',
  'red': 'function',
  'saturation': 'function',
  'background': 'function',
  'clear': 'function',
  'colorMode': 'function',
  'fill': 'function',
  'noFill': 'function',
  'noStroke': 'function',
  'stroke': 'function',
  'erase': 'function',
  'noErase': 'function',
  'createStringDict': 'function',
  'createNumberDict': 'function',
  'storeItem': 'function',
  'getItem': 'function',
  'clearStorage': 'function',
  'removeItem': 'function',
  'select': 'function',
  'selectAll': 'function',
  '_wrapElement': 'function',
  'removeElements': 'function',
  'createDiv': 'function',
  'createP': 'function',
  'createSpan': 'function',
  'createImg': 'function',
  'createA': 'function',
  'createSlider': 'function',
  'createButton': 'function',
  'createCheckbox': 'function',
  'createSelect': 'function',
  'createRadio': 'function',
  'createColorPicker': 'function',
  'createInput': 'function',
  'createFileInput': 'function',
  'createVideo': 'function',
  'createAudio': 'function',
  'VIDEO': 'string',
  'AUDIO': 'string',
  'createCapture': 'function',
  'createElement': 'function',
  'deviceOrientation': 'string',
  'accelerationX': 'number',
  'accelerationY': 'number',
  'accelerationZ': 'number',
  'pAccelerationX': 'number',
  'pAccelerationY': 'number',
  'pAccelerationZ': 'number',
  '_updatePAccelerations': 'function',
  'rotationX': 'number',
  'rotationY': 'number',
  'rotationZ': 'number',
  'pRotationX': 'number',
  'pRotationY': 'number',
  'pRotationZ': 'number',
  'pRotateDirectionX': 'undefined',
  'pRotateDirectionY': 'undefined',
  'pRotateDirectionZ': 'undefined',
  '_updatePRotations': 'function',
  'turnAxis': 'undefined',
  'setMoveThreshold': 'function',
  'setShakeThreshold': 'function',
  '_ondeviceorientation': 'function',
  '_ondevicemotion': 'function',
  '_handleMotion': 'function',
  'isKeyPressed': 'boolean',
  'keyIsPressed': 'boolean',
  'key': 'string',
  'keyCode': 'number',
  '_onkeydown': 'function',
  '_onkeyup': 'function',
  '_onkeypress': 'function',
  '_onblur': 'function',
  'keyIsDown': 'function',
  '_areDownKeys': 'function',
  'movedX': 'number',
  'movedY': 'number',
  '_hasMouseInteracted': 'boolean',
  'mouseX': 'number',
  'mouseY': 'number',
  'pmouseX': 'number',
  'pmouseY': 'number',
  'winMouseX': 'number',
  'winMouseY': 'number',
  'pwinMouseX': 'number',
  'pwinMouseY': 'number',
  'mouseButton': 'number',
  'mouseIsPressed': 'boolean',
  '_updateNextMouseCoords': 'function',
  '_updateMouseCoords': 'function',
  '_setMouseButton': 'function',
  '_onmousemove': 'function',
  '_onmousedown': 'function',
  '_onmouseup': 'function',
  '_ondragend': 'function',
  '_ondragover': 'function',
  '_onclick': 'function',
  '_ondblclick': 'function',
  '_mouseWheelDeltaY': 'number',
  '_pmouseWheelDeltaY': 'number',
  '_onwheel': 'function',
  'requestPointerLock': 'function',
  'exitPointerLock': 'function',
  'touches': 'object',
  '_updateTouchCoords': 'function',
  '_ontouchstart': 'function',
  '_ontouchmove': 'function',
  '_ontouchend': 'function',
  'createImage': 'function',
  'saveCanvas': 'function',
  'saveGif': 'function',
  'saveFrames': 'function',
  '_makeFrame': 'function',
  'loadImage': 'function',
  'image': 'function',
  'tint': 'function',
  'noTint': 'function',
  '_getTintedImageCanvas': 'function',
  'imageMode': 'function',
  'pixels': 'object',
  'blend': 'function',
  'copy': 'function',
  '_copyHelper': 'function',
  'filter': 'function',
  'get': 'function',
  'loadPixels': 'function',
  'set': 'function',
  'updatePixels': 'function',
  'loadJSON': 'function',
  'loadStrings': 'function',
  'loadTable': 'function',
  'loadXML': 'function',
  'loadBytes': 'function',
  'httpGet': 'function',
  'httpPost': 'function',
  'httpDo': 'function',
  '_pWriters': 'object',
  'createWriter': 'function',
  'save': 'function',
  'saveJSON': 'function',
  'saveJSONObject': 'function',
  'saveJSONArray': 'function',
  'saveStrings': 'function',
  'saveTable': 'function',
  'writeFile': 'function',
  'downloadFile': 'function',
  '_checkFileExtension': 'function',
  '_isSafari': 'function',
  'abs': 'function',
  'ceil': 'function',
  'constrain': 'function',
  'dist': 'function',
  'exp': 'function',
  'floor': 'function',
  'lerp': 'function',
  'log': 'function',
  'mag': 'function',
  'map': 'function',
  'max': 'function',
  'min': 'function',
  'norm': 'function',
  'pow': 'function',
  'round': 'function',
  'sq': 'function',
  'sqrt': 'function',
  'fract': 'function',
  'createVector': 'function',
  'noise': 'function',
  'noiseDetail': 'function',
  'noiseSeed': 'function',
  '_lcg': 'function',
  '_lcgSetSeed': 'function',
  'randomSeed': 'function',
  'random': 'function',
  'randomGaussian': 'function',
  '_angleMode': 'string',
  'acos': 'function',
  'asin': 'function',
  'atan': 'function',
  'atan2': 'function',
  'cos': 'function',
  'sin': 'function',
  'tan': 'function',
  'degrees': 'function',
  'radians': 'function',
  'angleMode': 'function',
  '_toRadians': 'function',
  '_toDegrees': 'function',
  '_fromRadians': 'function',
  'textAlign': 'function',
  'textLeading': 'function',
  'textSize': 'function',
  'textStyle': 'function',
  'textWidth': 'function',
  'textAscent': 'function',
  'textDescent': 'function',
  '_updateTextMetrics': 'function',
  'loadFont': 'function',
  'text': 'function',
  'textFont': 'function',
  'append': 'function',
  'arrayCopy': 'function',
  'concat': 'function',
  'reverse': 'function',
  'shorten': 'function',
  'shuffle': 'function',
  'sort': 'function',
  'splice': 'function',
  'subset': 'function',
  'float': 'function',
  'int': 'function',
  'str': 'function',
  'boolean': 'function',
  'byte': 'function',
  'char': 'function',
  'unchar': 'function',
  'hex': 'function',
  'unhex': 'function',
  'join': 'function',
  'match': 'function',
  'matchAll': 'function',
  'nf': 'function',
  'nfc': 'function',
  'nfp': 'function',
  'nfs': 'function',
  'split': 'function',
  'splitTokens': 'function',
  'trim': 'function',
  'day': 'function',
  'hour': 'function',
  'minute': 'function',
  'millis': 'function',
  'month': 'function',
  'second': 'function',
  'year': 'function',
  'plane': 'function',
  'box': 'function',
  'sphere': 'function',
  'cylinder': 'function',
  'cone': 'function',
  'ellipsoid': 'function',
  'torus': 'function',
  'orbitControl': 'function',
  'debugMode': 'function',
  'noDebugMode': 'function',
  '_grid': 'function',
  '_axesIcon': 'function',
  'ambientLight': 'function',
  'specularColor': 'function',
  'directionalLight': 'function',
  'pointLight': 'function',
  'lights': 'function',
  'lightFalloff': 'function',
  'spotLight': 'function',
  'noLights': 'function',
  'loadModel': 'function',
  'model': 'function',
  'loadShader': 'function',
  'createShader': 'function',
  'shader': 'function',
  'resetShader': 'function',
  'normalMaterial': 'function',
  'texture': 'function',
  'textureMode': 'function',
  'textureWrap': 'function',
  'ambientMaterial': 'function',
  'emissiveMaterial': 'function',
  'specularMaterial': 'function',
  'shininess': 'function',
  'isSupported': 'function',
  'isFileSupported': 'function',
  'getAudioContext': 'function',
  'userStartAudio': 'function',
  // 'getMasterVolume': 'function',
  // 'masterVolume': 'function',
  'soundOut': 'object',
  'sampleRate': 'function',
  'freqToMidi': 'function',
  'midiToFreq': 'function',
  'soundFormats': 'function',
  'disposeSound': 'function',
  '_checkFileFormats': 'function',
  '_mathChain': 'function',
  'loadSound': 'function',
  'createConvolver': 'function',
  'setBPM': 'function',
  'saveSound': 'function',
};
module.exports = P5LoaderPrototypeInfo;
